import { EquipmentView } from "@/features/equipment/components/EquipmentView"

export default function EquipmentPage() {
  return <EquipmentView />
}